export default {
  'CHANGE_RENT' (state, payload) {
    state.items = [...state.items, ...JSON.parse(JSON.stringify(payload))]
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/rents/mutations.js